import React from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import Img1 from '../assets/testemonial1.png';
import Img2 from '../assets/testimonial2.png';
import Img3 from '../assets/testemonial3.png';
import Img4 from '../assets/testimonial4.png';
import Img5 from '../assets/testemonial5.png';
import Img6 from '../assets/testimonial6.png';
import Img7 from '../assets/testimonial7.png';
import ImgLarge from '../assets/testemonialLarge.png';
import UsersIcon from '../assets/users.svg';
import ViewMoreIcon from '../assets/plusIcon.svg';

export const Testimonials: React.FC = () => {
  return (
    <Container
      id="reviews"
      fluid
      className="justify-content-center"
      style={{ paddingTop: 120, paddingBottom: 200 }}
    >
      <Row className="w-100 justify-content-center">
        <Col xs={12} className="d-flex flex-column align-items-center text-center">
          <div
            style={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 500,
              fontSize: 64,
              lineHeight: '100%',
              letterSpacing: '-2%',
              color: '#FFFFFF',
            }}
          >
            How we are growing their audience
          </div>
        </Col>
      </Row>

      <div style={{ width: '80%', margin: '40px auto 0' }}>
        <style>{`
          .testi-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }
          .testi-grid img, .testi-grid .ph { width: 100%; height: 100%; object-fit: cover; border-radius: 12px; }
          .testi-item--span { grid-column: 2; grid-row: 2 / span 2; }
          .testi-cell { min-height: 220px; }
          .testi-users-bar__divider {
            position: absolute;
            left: 65%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 1px;
            height: 28px;
            background-color: rgba(255,255,255,0.1);
            flex-shrink: 0;
          }
          .testi-users-bar {
            width: 100%;
            max-width: 475px;
            height: 54px;
            border-radius: 99px;
            padding: 6px 12px 6px 8px;
            background: #FFFFFF33;
            backdrop-filter: blur(24px);
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            gap: 12px;
            position: relative;
            box-sizing: border-box;
          }
          .testi-users-bar__left {
            display: flex;
            align-items: center;
            gap: 10px;
            min-width: 0;
            flex: 1 1 auto;
          }
          .testi-users-bar__icon {
            height: 54px;
            width: auto;
            flex-shrink: 0;
            object-fit: contain;
            display: block;
            margin: -6px 0;
          }
          .testi-users-bar__text,
          .testi-users-bar__action-text {
            font-family: Inter, sans-serif;
            font-weight: 500;
            font-size: 18px;
            line-height: 24px;
            color: #FFFFFFCC;
            white-space: nowrap;
          }
          .testi-users-bar__action {
            flex-shrink: 0;
            margin-left: auto;
            margin-right: 10px;
            padding: 0;
          }
          .testi-users-bar__action-text {
            margin-right: 8px;
          }
          .testi-users-bar__action-icon {
            background-color: #FFFFFF;
            padding: 4px;
            border-radius: 99px;
            height: 18px;
            width: auto;
            flex-shrink: 0;
          }
          @media (max-width: 992px) {
            .testi-grid { grid-template-columns: 1fr; }
            .testi-item--span { grid-column: auto; grid-row: auto; }
            .testi-cell { min-height: 200px; }
            .testi-cell--hide-mobile { display: none; }
            .testi-users-bar { gap: 8px; padding-right: 8px; }
            .testi-users-bar__text,
            .testi-users-bar__action-text {
              font-size: clamp(10px, 2.7vw, 13px);
              line-height: 1.2;
            }
            .testi-users-bar__action { margin-right: 0; }
            .testi-users-bar__divider { display: none; }
            .testi-users-bar__icon { height: 36px; }
          }
        `}</style>

        <div className="testi-grid">
          <div className="testi-cell">
            <Image
              src={Img1}
              alt="t1"
              className="w-100 h-100"
              style={{ objectFit: 'cover', borderRadius: 12 }}
            />
          </div>
          <div className="testi-cell testi-cell--hide-mobile">
            <Image
              src={Img2}
              alt="t2"
              className="w-100 h-100"
              style={{ objectFit: 'cover', borderRadius: 12 }}
            />
          </div>
          <div className="testi-cell testi-cell--hide-mobile">
            <Image
              src={Img3}
              alt="t3"
              className="w-100 h-100"
              style={{ objectFit: 'cover', borderRadius: 12 }}
            />
          </div>

          <div className="testi-cell testi-cell--hide-mobile">
            <Image
              src={Img4}
              alt="t4"
              className="w-100 h-100"
              style={{ objectFit: 'cover', borderRadius: 12 }}
            />
          </div>
          <div className="testi-cell testi-item--span">
            <Image
              src={ImgLarge}
              alt="tLarge"
              className="w-100 h-100"
              style={{ objectFit: 'cover', borderRadius: 12 }}
            />
          </div>
          <div className="testi-cell testi-cell--hide-mobile">
            <Image
              src={Img5}
              alt="t5"
              className="w-100 h-100"
              style={{ objectFit: 'cover', borderRadius: 12 }}
            />
          </div>

          <div className="testi-cell testi-cell--hide-mobile">
            <Image
              src={Img6}
              alt="t6"
              className="w-100 h-100"
              style={{ objectFit: 'cover', borderRadius: 12 }}
            />
          </div>
          <div className="testi-cell testi-cell--hide-mobile">
            <Image
              src={Img7}
              alt="t7"
              className="w-100 h-100"
              style={{ objectFit: 'cover', borderRadius: 12 }}
            />
          </div>
        </div>
      </div>

      <Row className="w-100 justify-content-center" style={{ marginTop: 40 }}>
        <Col xs={12} className="d-flex justify-content-center">
          <div className="testi-users-bar">
            <div className="testi-users-bar__left">
              <Image src={UsersIcon} alt="users" className="testi-users-bar__icon" />
              <span className="testi-users-bar__text">+10,000 users enjoy Cero</span>
            </div>
            <div className="testi-users-bar__divider" aria-hidden="true" />
            <Button
              variant="link"
              className="testi-users-bar__action text-decoration-none d-flex align-items-center"
            >
              <span className="testi-users-bar__action-text">View More</span>
              <Image
                src={ViewMoreIcon}
                alt="view more"
                className="testi-users-bar__action-icon"
              />
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
